export const cartDatalocator = {
    cart_cartEmpty_lbl: 'cart_cartEmpty_lbl',
    cart_exploreVarietyTools_lbl: 'cart_exploreVarietyTools_lbl',
    cart_exploreRentals_CTA: 'cart_exploreRentals_CTA',
    cart_rentals_title: 'cart_rentals_title',
    cart_unavailabel_rentals_title: 'cart_unavailabel_rentals_title',
    cart_item: 'cart_item',
    cart_view_similar_cta: 'view_similar_cta',
    cart_shimmer: 'cart-shimmer',
    cart_order_summary_shimmer: 'order-summary-shimmer',
    cart_footer_shimmer: 'footer-shimmer',
    cart_layout_product_image_testid: 'cart_layout_product_image',
    cart_layout_product_name_testid: 'cart_layout_product_name',
    remove_cta_testid: 'remove_item_cta',
    cart_product_added_consumables: 'product_added_consumables',
    cart_product_consumables_action: 'product_consumables_action',
    cart_product_consumables_view_other: 'product_consumables_view_other',
    cart_product_consumables_remove: 'product_consumables_remove',
    cart_added_consumable_price: 'added_consumable_price',
    cart_rental_equipment_accessories_heading: 'cart_rental_equipment_accessories_heading',
    cart_accessories_and_addons_needhelp_label: 'cart_needhelp_label',
    cart_store_phoneNumber: 'cart_storephonenumber_label',
    cart_rental_equipment_addons_heading: 'cart_rental_equipment_addons_heading',
    cart_rental_equipment_close: 'cart_rental_equipment_close',
    cart_accessories_cross_icon_testid: 'cart_accessories_cross_icon',
    cart_accessories_returnToCheckout_CTA_testid: 'cart_accessories_returnToCheckout_CTA',
    cart_accessories_cancel_CTA_testid: 'cart_accessories_cancel_CTA',
    cart_rental_equipment_submit: 'cart_rental_equipment_submit',
    equipment_unavailable_view_category_cta: 'equipment_unavailable_view_category_cta',
    equipment_unavailable_close_icon: 'equipment_unavailable_close_icon',
    equipment_unavailable_go_back_cta: 'equipment_unavailable_go_back_cta',
    equipment_available_close_icon: 'equipment_available_go_back_cta',
    equipment_similar_item_click: 'equipment_similar_item_click',
};
